export default __webpack_public_path__ + "static/media/syspingif.306d33d7.gif";